import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { RestaurantContextService } from "../services/restaurant-context.service";

export const RESTAURANT_CONTEXT_HEADER = "X-Menuvia-Restaurant-Id";

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(AuthService).token;
  const contextHeader = inject(RestaurantContextService).outletHeaderValue();

  const headers: Record<string, string> = {};
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  if (contextHeader) {
    headers[RESTAURANT_CONTEXT_HEADER] = contextHeader;
  }

  return Object.keys(headers).length
    ? next(req.clone({ setHeaders: headers }))
    : next(req);
};
